import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import apiProvider from '../apiProvider/api';
import ReactTableComponent from "../table/ReactTableComponent";


const ContactUsListLayer = () => {
    const [userData, setUserData] = useState([]);
    const [pageIndex, setPageIndex] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const input = {
                page: pageIndex, // API usually expects 1-based page
                limit: pageSize,
                search: search
            };
            const result = await apiProvider.getContactUs(input);
            if (result && result.status) {
                setUserData(result.response.data || []);
                setTotalPages(result.response.totalPages || 1);
                setTotal(result.response.total || 0);
            }
        } catch (error) {
            console.error("Error fetching contact requests:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [pageIndex, pageSize, search]);

    const handleNextPage = () => {
        if (pageIndex + 1 < totalPages) setPageIndex(prev => prev + 1);
    };

    const handlePreviousPage = () => {
        if (pageIndex > 0) setPageIndex(prev => prev - 1);
    };

    const searchDebounceRef = useRef(null);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchInput(value);
        setPageIndex(0); // reset to first page

        if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);

        searchDebounceRef.current = setTimeout(() => {
            setSearch(value);
        }, 300);
    };

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                cell: info => (pageIndex * pageSize) + info.row.index + 1,
                size: 50
            },
            {
                header: 'Name',
                accessorKey: 'fullName',
                cell: info => info.getValue(),
            },
            {
                header: 'Email',
                accessorKey: 'email',
                cell: info => info.getValue(),
            },
            {
                header: 'Phone',
                accessorKey: 'phone',
                cell: info => info.getValue(),
            },
            {
                header: 'Country',
                accessorKey: 'country',
                cell: info => info.getValue(),
            },
            {
                header: 'Message',
                accessorKey: 'message',
                cell: info => (
                    <div style={{ whiteSpace: 'normal', minWidth: '200px' }}>
                        {info.getValue() || '-'}
                    </div>
                ),
            },
            {
                header: 'Date',
                accessorKey: 'createdAt',
                cell: info => info.getValue() ? new Date(info.getValue()).toLocaleString() : '-',
            }

        ],
        [pageIndex, pageSize]
    );

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div style={{ position: "relative" }}>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                        style={{ maxWidth: 350 }}
                        value={searchInput}
                        onChange={handleSearchChange}
                    />
                    <Icon
                        icon="ic:baseline-search"
                        style={{
                            position: "absolute",
                            right: 10,
                            top: 10,
                            fontSize: 20,
                        }}
                    />
                </div>
            </div>

            <div className="card-body p-24">
                <div className="table-responsive scroll-sm">
                    <ReactTableComponent
                        data={userData}
                        columns={columns}
                        pageIndex={pageIndex}
                        totalPages={totalPages}
                        totalRecords={total}
                        onNextPage={handleNextPage}
                        onPreviousPage={handlePreviousPage}
                        pageSize={pageSize}
                    />
                </div>
            </div>
        </div>
    );
};

export default ContactUsListLayer;